import { render, staticRenderFns } from "./usersRole.vue?vue&type=template&id=7f191d4a&"
import script from "./usersRole.vue?vue&type=script&lang=js&"
export * from "./usersRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports